import { useEffect } from 'react';
import { EVT, gameEvents } from '../game/events';
import { useT, type TKey } from '../i18n';
import { pushToast } from './Toast';

/**
 * Phase 2t: subscribes to EvolutionUnlocked events and pushes a localized
 * "success"-variant toast with the evolution's display name.
 * Mount once in the App.tsx run-branch — NOT inside the 3a menu-branch wrapper.
 */
export function EvolutionUnlockSubscriber(): null {
  const { t } = useT();
  useEffect(() => {
    const handler = (payload: { id: string }) => {
      pushToast({
        variant: 'success',
        title: t(`evolution.${payload.id}.name` as TKey),
        durationMs: 2500,
      });
    };
    gameEvents.on(EVT.EvolutionUnlocked, handler as never);
    return () => {
      gameEvents.off(EVT.EvolutionUnlocked, handler as never);
    };
  }, [t]);
  return null;
}
